@if (loading) {
  <div class="tw-text-center">
    <i
      class="bwi bwi-spinner bwi-spin bwi-2x tw-text-muted"
      title="{{ 'loading' | i18n }}"
      aria-hidden="true"
    ></i>
    <span class="tw-sr-only">{{ "loading" | i18n }}</span>
  </div>
} @else {
  <p>{{ "removeMasterPasswordForOrgUserKeyConnector" | i18n }}</p>
  <p class="tw-mb-0 tw-font-bold">{{ "organization" | i18n }}</p>
  <p class="tw-mb-6">{{ organization.name }}</p>
  <p class="tw-mb-0 tw-font-bold tw-inline-flex tw-items-center">
    {{ "domain" | i18n }}
    <button
      type="button"
      [label]="'keyConnectorDomainTooltip' | i18n"
      tooltipPosition="above-center"
      bitIconButton="bwi-info-circle"
      size="small"
    ></button>
  </p>
  <p class="tw-mb-6 tw-font-mono">{{ keyConnectorHostName }}</p>

  <div class="tw-flex tw-flex-col tw-gap-2">
    <button bitButton type="button" buttonType="primary" [block]="true" [bitAction]="convert">
      {{ "continueWithLogIn" | i18n }}
    </button>

    <button bitButton type="button" buttonType="secondary" [block]="true" [bitAction]="leave">
      {{ "doNotContinue" | i18n }}
    </button>
  </div>
}
